var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgChangesInMyLife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 29.996V0h30v29.996z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E77D66",
    d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2F424F",
    d: "M15 24.262a6.381 6.381 0 1 1 0-12.763 6.381 6.381 0 0 1 0 12.763zm0-15.476c-4.571 0-8.286 3.714-8.286 8.285 0 4.572 3.715 8.286 8.286 8.286s8.286-3.69 8.286-8.262c0-4.571-3.715-8.31-8.286-8.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACAF",
    d: "M10 6.5l5 5.619L11.667 6.5H10M18.333 6.5L15 12.119 20 6.5h-1.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.667 6.5L15 12.119 13.619 6.5h-1.952M16.381 6.5L15 12.119 18.333 6.5h-1.952"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACAF",
    d: "M13.619 6.5L15 12.119 16.381 6.5h-2.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EA",
    d: "M15 6.5h2.214l-1.119-1.881L15 6.5M10 6.5h2.762l-1.095-1.881L10 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EA",
    d: "M12.762 6.5H15l-1.119-1.881-1.12 1.881M18.333 4.619L17.214 6.5H20l-1.667-1.881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACAF",
    d: "M11.667 4.619L12.762 6.5l1.119-1.881h-2.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACAF",
    d: "M13.881 4.619L15 6.5l1.095-1.881h-2.214M16.095 4.619l1.12 1.881 1.118-1.881h-2.238"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangesInMyLife);
export default __webpack_public_path__ + "static/media/changes-in-my-life.15b337aa3c4a0b33ae44deb94ae458f6.svg";
export { ForwardRef as ReactComponent };